import { useCallback } from 'react';
import { useTRPCAPI, useTRPCClientAPI, useTRPCMutation, useTRPCQuery } from '../../trpc/trpc';

/** Everything the Team settings tab needs: the roster, pending invites, and the three actions on it. */
export function useTeam() {
  const trpcAPI = useTRPCAPI();
  const trpcClient = useTRPCClientAPI();
  const {
    data,
    isLoading,
    error,
    refetch: refetchUnsafe,
  } = useTRPCQuery(trpcAPI.team.list.queryOptions(undefined, { retry: false }));
  const refetch = useCallback(() => {
    refetchUnsafe().catch(console.error);
  }, [refetchUnsafe]);

  const invite = useTRPCMutation({
    mutationFn: (input: { email: string }) => trpcClient.team.invite.mutate(input),
    onSuccess: refetch,
  });
  const revokeInvite = useTRPCMutation({
    mutationFn: (input: { inviteId: number }) => trpcClient.team.revokeInvite.mutate(input),
    onSuccess: refetch,
  });
  const removeMember = useTRPCMutation({
    mutationFn: (input: { userId: number }) => trpcClient.team.removeMember.mutate(input),
    onSuccess: refetch,
  });
  return { data, isLoading, error, refetch, invite, revokeInvite, removeMember };
}
